"use client";

import { useEffect } from "react";
import { captureAdTouch } from "../../library/ad-touch";
import { CONSENT_EVENT } from "../../library/cookie-consent";

/**
 * Records the paid-ad touch of this page (E12 P3, #586). Runs again when the
 * visitor gives consent, so an ad click whose visitor accepts the banner on
 * the landing page is still captured from that page's URL.
 */
export default function AdTouchCapture() {
  useEffect(() => {
    const capture = () => captureAdTouch();
    capture();
    window.addEventListener(CONSENT_EVENT, capture);
    return () => window.removeEventListener(CONSENT_EVENT, capture);
  }, []);
  return null;
}
